<div class="user">
  {{ userLogin$ | async }}
</div>
